import {
    AddUpdateRemoveCompanySelectionDescriptions,
    AddUpdateRemoveCompanySelectionDescriptionsFailure,
    AddUpdateRemoveCompanySelectionDescriptionsSuccess,
    LoadCompanySelectionDescriptionByCompanyId,
    LoadCompanySelectionDescriptionFailure,
    LoadCompanySelectionDescriptionSuccess,
    ReloadCompanySelectionDescriptionByIds,
    ReloadCompanySelectionDescriptionByIdsFailure,
    ReloadCompanySelectionDescriptionByIdsSuccess
} from '../actions/company-selection-description.actions';
import { CompanySelectionDescriptionDTO } from '@iota/iota-management-portal-v4-client';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, createSelector, on } from '@ngrx/store';
import { AppState } from '../store';

export interface CompanySelectionDescriptionState extends EntityState<CompanySelectionDescriptionDTO> {
    loading: boolean;
    error: any;
    loadedCompanies: string[];
}

function selectCompanySelectionDescriptionId(a: CompanySelectionDescriptionDTO): string {
    return a.companySelectionDescriptionId;
}

export const companySelectionDescriptionAdapter: EntityAdapter<CompanySelectionDescriptionDTO> =
    createEntityAdapter<CompanySelectionDescriptionDTO>({
        selectId: selectCompanySelectionDescriptionId
    });

export const initialState: CompanySelectionDescriptionState = companySelectionDescriptionAdapter.getInitialState({
    loading: false,
    error: undefined,
    loadedCompanies: []
});

export const companySelectionDescriptionReducer = createReducer(
    initialState,
    on(LoadCompanySelectionDescriptionByCompanyId, (state) => ({ ...state, loading: true })),
    on(ReloadCompanySelectionDescriptionByIds, (state) => ({ ...state, loading: true })),
    on(AddUpdateRemoveCompanySelectionDescriptions, (state) => ({ ...state, loading: true })),

    on(LoadCompanySelectionDescriptionSuccess, (state, { companySelectionDescriptions }) =>
        companySelectionDescriptionAdapter.setAll(companySelectionDescriptions || [], { ...state, loading: false })
    ),
    on(ReloadCompanySelectionDescriptionByIdsSuccess, (state, { companySelectionDescriptions }) =>
        companySelectionDescriptionAdapter.setAll(companySelectionDescriptions || [], {
            ...state,
            loading: false
        })
    ),
    on(AddUpdateRemoveCompanySelectionDescriptionsSuccess, (state) => ({ ...state, loading: false })),

    on(LoadCompanySelectionDescriptionFailure, (state, error) => ({ ...state, loading: false, error })),
    on(ReloadCompanySelectionDescriptionByIdsFailure, (state, error) => ({ ...state, loading: false, error })),
    on(AddUpdateRemoveCompanySelectionDescriptionsFailure, (state, error) => ({ ...state, loading: false, error }))
);

const { selectAll } = companySelectionDescriptionAdapter.getSelectors();

export const CompanySelectionDescription = (state: AppState) => state.companySelectionDescriptionState;
export const allCompanySelectionDescriptions = createSelector(CompanySelectionDescription, selectAll);
export const allCompanySelectionDescriptionsByCompany = (companyId: string) =>
    createSelector(allCompanySelectionDescriptions, (selections) => selections.filter((elem) => elem.companyId === companyId));
export const companySelectionDescriptionsByIds = (ids: string[]) =>
    createSelector(allCompanySelectionDescriptions, (selections) =>
        selections.filter((elem) => ids.includes(elem.companySelectionDescriptionId))
    );
export const companySelectionDescriptionsLoading = createSelector(CompanySelectionDescription, (state) => state.loading);
export const companySelectionDescriptionError = createSelector(CompanySelectionDescription, (state) => state.error);
export const companySelectionDescriptionsLoadedByCompany = (companyId: string) =>
    createSelector(CompanySelectionDescription, (state) => state.loadedCompanies?.includes(companyId));
